import React, { useState, useEffect } from "react";
import Axios from './../../../../utils/api/axiosConf';
import { url } from './../../../../utils/api/api';
import { RedNotif, GreenNotif } from "../../../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../../../components/loading/loading";
import { Col, Row } from "antd";
import SELECT from "./../../../../components/select/select";
import BUTTON from "./../../../../components/buttons/button";
import { color } from "./../../../../utils/themes/color";
import recycleImg from "./../../../../assets/images/recycleBin.jpg";



export default function ExercisesAthlete(props) {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState([]);
    const [data, setData] = useState([]);
    const [updator, setUpdator] = useState(1);
    const level = [{ "name": "حرفه ای", "value": "professional" }, { "name": "نیمه حرفه ای", "value": "semiProfessional" }, { "name": "متوسط", "value": "intermediate" }, { "name": "مبتدی", "value": "begginer" }]
    const [sport, setSport] = useState({ "exercise": null, "level": null })
    const [exerciseData, setExerciseData] = useState([]);
    const [exerciseMap, setExerciseMap] = useState([]);



    useEffect(() => {
        Axios.get(`${url}sport-fields/list`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    var x = [];
                    for (const iterator of response.data.docs) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setData(x)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log("ero", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])

    useEffect(() => {
        setLoading(true)
        Axios.get(`${url}users/get-athlete-exercises/${userId}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    if (response.data != null && response.data != undefined && response.data.length != 0) {
                        var x = [];
                        setExerciseMap(response.data)

                        for (const iterator of response.data) {
                            x.push({
                                name: iterator.level,
                                value: iterator._id
                            })
                        }
                        setExerciseData(x)


                    }
                    setLoading(false)

                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                console.log("er", error)
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updator])



    const updateExercises = () => {

        if (sport.exercise != "" && sport.exercise != null && sport.exercise != undefined && sport.level != "" && sport.level != null && sport.level != undefined) {

            var x = [];
            for (const iterator of exerciseData) {
                 x.push(
                    { "exercise": iterator.value, "level": iterator.name }
                )
            }
            x.push(
                { "exercise": sport.exercise, "level": sport.level }
            )

            var exercises = { "exercises": x }




            Axios.patch(`${url}users/athlete-exercises/${userId}`, exercises)
                .then(async (response) => {
                    if (response.status === 200 || response.status === 201) {
                        setUpdator(updator + 1)
                        GreenNotif(response.message);
                        setLoading(false);

                    } else {
                        RedNotif(response.message);
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                    console.log("error", error)
                    setLoading(false)
                });


            setLoading(true);
        } else {
            RedNotif("نام ورزش و سطح نمیتواند خالی باشد")
        }
    }


    const deleteExercises = (item) => {
        var x = [];
        exerciseMap.filter(function (obj) {
            if (obj.exercise != null && obj.exercise.title != null) {
                if (obj.exercise.title !== item.exercise.title) {

                    x.push(obj)
                }
            }
        });

        setExerciseMap(x)

    }



    const translator = (a) => {
        switch (a) {
            case "professional": return "حرفه ای"
            case "semiProfessional": return "نیمه حرفه ای"
            case "intermediate": return "متوسط"
            case "begginer": return "مبتدی"
            case "": return ""
            case null: return ""
        }
    }


    switch (loading) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>سوابق ورزشی خود را وارد نمایید:</p>
                    </Col>
                </Row>

                <Row>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} >
                        <SELECT
                            click={(e) => setSport({ ...sport, exercise: e })}
                            items={data}
                            value={sport.exercise}
                        />
                        <br /><br />
                        {
                            sport.exercise != null ?

                                <SELECT
                                    click={(e) => setSport({ ...sport, level: e })}
                                    items={level}
                                    value={sport.level} />


                                : null
                        }
                    </Col>
                </Row>

                <Row style={{ marginTop: '24px' }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ color: color.secondary, fontWeight: 'bold',cursor: "pointer" }} onClick={(e) => updateExercises()}>افزودن</p>
                    </Col>
                </Row>

                <Row gutter={[8, 16]} style={{ marginTop: '32px' }} >
                    {exerciseMap.map((item, index) =>
                        <Col offset={1} span={6} key={index} xxl={6} xl={6} lg={6} md={6} sm={6} style={{ border: `1px solid ${color.primary}`, background: "white", height: "38px" }}>

                            <Row style={{ marginRight: '18px', marginTop: '8px' }}>
                                <Col xxl={22} xl={22} lg={22} md={22} sm={22} style={{ marginBottom: '28px' }}>


                                    <p style={{ fontSize: "12px" }}>{item.exercise != null ? item.exercise.title != null ? item.exercise.title : "" : ""}_{translator(item.level)}</p>
                                </Col>
                                <Col xxl={2} xl={2} lg={2} md={2} sm={2} style={{ marginBottom: '28px' }}>
                                    <img src={recycleImg} style={{ width: "50%", cursor: "pointer" }} onClick={() => deleteExercises(item)} />
                                </Col>
                            </Row>

                        </Col>
                    )}

                </Row>


                <Row style={{ marginTop: '42px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => {
                            updateExercises()
                            {
                                if (sport.exercise != "" && sport.exercise != null && sport.exercise != undefined && sport.level != "" && sport.level != null && sport.level != undefined) {
                            props.pager(6)
                                }
                            }
                        
                        }} 
                            text="ثبت و بعدی" type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6}>
                        <BUTTON event={(e) => props.pager(6)} text="رد کردن" type={"cancel"} />

                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }

}

